const clientId = process.env.REACT_APP_MSAL_CLIENT_ID;
const authority = process.env.REACT_APP_MSAL_AUTHORITY;

const redirectUri = process.env.REACT_APP_MSAL_REDIRECT_URI || window.location.origin;
const postLogoutRedirectUri = process.env.REACT_APP_MSAL_POST_LOGOUT_REDIRECT_URI || window.location.origin;

export const msalConfig = {
  auth: {
    clientId: clientId,
    authority: authority,
    redirectUri: redirectUri,
    postLogoutRedirectUri: postLogoutRedirectUri,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case 0: // Error
            console.error('MSAL:', message);
            break;
          case 1: // Warning
            console.warn('MSAL:', message);
            break;
          case 2: // Info
            console.info('MSAL:', message);
            break;
          case 3: // Verbose
            console.debug('MSAL:', message);
            break;
          default:
            console.log('MSAL:', message);
        }
      },
      logLevel: 3, // Verbose
    }
  }
};

export const loginRequest = {
  scopes: ["User.Read"],
};
